import * as Yup from 'yup';

export default Yup.object().shape({
  dateRange: Yup.array()
    .of(Yup.string())
    .min(2)
    .max(2)
    .nullable()
    .required('Required'),
  shiftTime: Yup.number().required('Required'),
  rate: Yup.number().required('Required'),
  notes: Yup.string(),
});
